import actions from './constants';

export const fetchDictionaryReports = (category, code, reportType) => ({
  category,
  code,
  reportType,
  type: actions.FETCH_DICTIONARY_REPORTS,
});

export const fetchDictionaryReportsSuccess = (category, code, reportType, result) => ({
  category,
  code,
  reportType,
  result,
  type: actions.FETCH_DICTIONARY_REPORTS_SUCCESS,
});

export const fetchDictionaryReportsError = (category, code, reportType, error) => ({
  category,
  code,
  reportType,
  error,
  type: actions.FETCH_DICTIONARY_REPORTS_ERROR,
});

export const showDictionaryReports = (category, code, name, reportType) => ({
  category,
  code,
  name,
  reportType,
  type: actions.SHOW_DICTIONARY_REPORTS,
});

export const hideDictionaryReports = (category, code, reportType) => ({
  type: actions.HIDE_DICTIONARY_REPORTS,
  category,
  code,
  reportType,
});

export const showDictionaryReport = (category, code, reportType, reportId) => ({
  type: actions.SHOW_DICTIONARY_REPORT,
  category,
  code,
  reportType,
  reportId,
});

export const hideDictionaryReport = (category, code, reportType, reportId) => ({
  category,
  code,
  reportId,
  reportType,
  type: actions.HIDE_DICTIONARY_REPORT,
});

export const dictionaryReportDownload = (category, code, reportType, report, downloadFile) => ({
  type: actions.DICTIONARY_REPORT_DOWNLOAD,
  category,
  code,
  reportType,
  report,
  downloadFile,
});

export const dictionaryReportDownloadSuccess = (category, code, reportType, report, response) => ({
  type: actions.DICTIONARY_REPORT_DOWNLOAD_SUCCESS,
  category,
  code,
  reportType,
  report,
  response,
});

export const dictionaryReportDownloadError = (
  category,
  code,
  reportType,
  report,
  error,
  downloadFile,
) => ({
  type: actions.DICTIONARY_REPORT_DOWNLOAD_ERROR,
  category,
  code,
  reportType,
  report,
  error,
  downloadFile,
});

export const fetchDataModelReports = (category, code) => ({
  category,
  code,
  type: actions.FETCH_DATA_MODEL_REPORTS,
});

export const fetchDataModelReportsSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.FETCH_DATA_MODEL_REPORTS_SUCCESS,
});

export const fetchDataModelReportsError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_DATA_MODEL_REPORTS_ERROR,
});

export const showDataModelReports = (category, code, name) => ({
  category,
  code,
  name,
  type: actions.SHOW_DATA_MODEL_REPORTS,
});

export const hideDataModelReports = (category, code) => ({
  type: actions.HIDE_DATA_MODEL_REPORTS,
  category,
  code,
});

export const dataModelReportDownload = (category, code, report, downloadFile) => ({
  type: actions.DATA_MODEL_REPORT_DOWNLOAD,
  category,
  code,
  report,
  downloadFile,
});

export const dataModelReportDownloadSuccess = (category, code, report, response) => ({
  type: actions.DATA_MODEL_REPORT_DOWNLOAD_SUCCESS,
  category,
  code,
  report,
  response,
});

export const dataModelReportDownloadError = (
  category,
  code,
  report,
  error,
  downloadFile,
) => ({
  type: actions.DATA_MODEL_REPORT_DOWNLOAD_ERROR,
  category,
  code,
  report,
  error,
  downloadFile,
});
